import {
    ChangeDetectionStrategy,
    Component,
    ElementRef,
    HostBinding,
    Input,
    OnChanges,
    OnInit,
    Renderer2,
    SimpleChanges,
} from "@angular/core";
import { ButtonKind, ButtonType, SpsIcon } from "@spscommerce/ds-shared";
import { AttributePresenceInput } from "@spscommerce/ng-utils";

@Component({
    selector: "sps-button",
    templateUrl: "./sps-button.component.html",
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SpsButtonComponent implements OnChanges, OnInit {
    static readonly displayName = "sps-button";
    static readonly props = {
        kind: "ButtonKind",
        type: "ButtonType",
        href: "string",
        icon: "SpsIcon",
        spinning: "boolean",
        disabled: "boolean",
    };

    @Input() kind: ButtonKind = ButtonKind.DEFAULT;
    @Input() type: ButtonType = ButtonType.BUTTON;
    @Input() href: string;
    @Input() target: string;
    @Input() icon: SpsIcon;
    @Input("aria-label") ariaLabel: string;

    @HostBinding("class.sps-btn--spinning")
    @Input() spinning = false;

    @HostBinding("class.disabled")
    @AttributePresenceInput()
    @Input()
    disabled;

    @HostBinding("class.sps-btn") readonly _spsBtnClass = true;

    constructor(private _elementRef: ElementRef, private _renderer: Renderer2) { }

    ngOnInit() {
        this._renderer.addClass(this._elementRef.nativeElement, `sps-btn--${this.kind}`);
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes.kind) {
            this._renderer.removeClass(this._elementRef.nativeElement, `sps-btn--${changes.kind.previousValue}`);
            this._renderer.addClass(this._elementRef.nativeElement, `sps-btn--${changes.kind.currentValue}`);
        }
    }

    onButtonClick(event: MouseEvent) {
        if (this.disabled) {
            event.preventDefault();
            event.stopPropagation();
        }
    }
}
